var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 0.5C3.785 0.5 2.1875 2.0975 2.1875 4.0625C2.1875 5.99 3.695 7.55 5.66 7.6175C5.72 7.61 5.78 7.61 5.825 7.6175C5.84 7.6175 5.8475 7.6175 5.8625 7.6175C5.87 7.6175 5.87 7.6175 5.8775 7.6175C7.7975 7.55 9.305 5.99 9.3125 4.0625C9.3125 2.0975 7.715 0.5 5.75 0.5Z",
    fill: "#0044EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55875 9.61266C7.46625 8.21766 4.05375 8.21766 1.94625 9.61266C0.99375 10.2502 0.46875 11.1127 0.46875 12.0352C0.46875 12.9577 0.99375 13.8127 1.93875 14.4427C2.98875 15.1477 4.36875 15.5002 5.74875 15.5002C7.12875 15.5002 8.50875 15.1477 9.55875 14.4427C10.5037 13.8052 11.0288 12.9502 11.0288 12.0202C11.0213 11.0977 10.5037 10.2427 9.55875 9.61266Z",
    fill: "#0044EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.992 4.50507C14.112 5.96007 13.077 7.23507 11.6445 7.40757C11.637 7.40757 11.637 7.40757 11.6295 7.40757H11.607C11.562 7.40757 11.517 7.40757 11.4795 7.42257C10.752 7.46007 10.0845 7.22757 9.58203 6.80007C10.3545 6.11007 10.797 5.07507 10.707 3.95007C10.6545 3.34257 10.4445 2.78757 10.1295 2.31507C10.4145 2.17257 10.7445 2.08257 11.082 2.05257C12.552 1.92507 13.8645 3.02007 13.992 4.50507Z",
    fill: "#0044EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4922 11.4423C15.4322 12.1698 14.9672 12.7998 14.1872 13.2273C13.4372 13.6398 12.4922 13.8348 11.5547 13.8123C12.0947 13.3248 12.4097 12.7173 12.4697 12.0723C12.5447 11.1423 12.1022 10.2498 11.2172 9.53731C10.7147 9.13981 10.1297 8.82481 9.49219 8.59231C11.1497 8.11231 13.2347 8.43481 14.5172 9.46981C15.2072 10.0248 15.5597 10.7223 15.4922 11.4423Z",
    fill: "#0044EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon_users.5804b8872103bc98df1e2e573c1330c5.svg";
export { ForwardRef as ReactComponent };